import { useMutation, useQueryClient } from 'react-query';
import quoterApiInstance from '../../api/quoterApiInstance';
import { QUERY_KEYS, MUTATION_KEYS } from '../../constants/reactQuery';

const deleteFavoritePlan = async (id) => {
    const { data } = await quoterApiInstance.delete(`/my-favorite-plans/${id}`);
    return data;
};

/**
 * Deletes a favorite plan by id.
 *
 * On success it invalidates both the plans list and the metrics queries so the
 * dashboard table and the metric cards refresh with the new data.
 */
export const useDeleteFavoritePlan = (options = {}) => {
    const queryClient = useQueryClient();

    return useMutation(
        MUTATION_KEYS.favoritePlans.delete,
        (id) => deleteFavoritePlan(id),
        {
            ...options,
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(QUERY_KEYS.favoritePlans.all);
                queryClient.invalidateQueries(QUERY_KEYS.favoritePlanMetrics.all);
                options.onSuccess?.(data, variables, context);
            },
            onError: (error, variables, context) => {
                console.error('Error deleting favorite plan:', error);
                options.onError?.(error, variables, context);
            },
        }
    );
};

export default useDeleteFavoritePlan;
